import { c as __rest, d as __assign } from '../../chunks/chunk-525a49bc.js';
import 'antd';
import React from 'react';
import 'styled-components';
import '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { a as withAsset } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'lodash';
import 'moment';
import '../../chunks/chunk-06cde6d9.js';
import { DescriptionList as Component } from '../DescriptionList/index.js';

var AssetDetailsPanelPure = function (_a) {
    var asset = _a.asset, children = _a.children, restProps = __rest(_a, ["asset", "children"]);
    return React.createElement(Component, __assign({ valueSet: asset.metadata || {} }, restProps));
};

// Copyright 2020 Cognite AS
var AssetDetailsPanel = withAsset(AssetDetailsPanelPure);

export { AssetDetailsPanel };
